<script
  setup
  lang="ts"
  generic="
    ListingFilter extends {
      code: string;
      label: string;
    }
  "
>
import type { Schemas } from "#shopware";
import { computed, ref } from "vue";

const emits = defineEmits<{
  (e: "select-value", value: { code: string; value: unknown }): void;
}>();

const props = defineProps<{
  filter: ListingFilter;
  selectedFilters: Schemas["ProductListingResult"]["currentFilters"];
}>();
const isHoverActive = ref(false);
const hoveredIndex = ref(0);
const displayedScore = computed(() =>
  isHoverActive.value ? hoveredIndex.value : props.selectedFilters?.rating || 0
);

const hoverRating = (key: number) => {
  hoveredIndex.value = key;
  isHoverActive.value = true;
};
const onChangeRating = () => {
  const newValue =
    props.selectedFilters?.rating !== hoveredIndex.value
      ? hoveredIndex.value
      : undefined;
  emits("select-value", { code: props.filter?.code, value: newValue });
};

const isFilterVisible = ref<boolean>(true);
const toggle = () => {
  isFilterVisible.value = !isFilterVisible.value;
};

if (props.selectedFilters?.rating) {
  toggle();
}
</script>

<template>
  <div class="filter-rating-element">
    <button
      class="accordion-header w-full text-left py-4 font-bold flex justify-between items-center cursor-pointer bg-transparent"
      @click="toggle"
    >
      <span class="text-base font-bold text-dark-bg">{{
        props.filter.label
      }}</span>
      <svg
        id="icon-price"
        xmlns="http://www.w3.org/2000/svg"
        class="h-[16px] w-[16px] transform transition-transform duration-200"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        :class="[!isFilterVisible ? 'rotate-0' : 'rotate-180']"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        ></path>
      </svg>
    </button>
    <transition name="fade" mode="out-in">
      <div v-show="isFilterVisible" class="accordion-body">
        <div class="flex pb-4">
          <div
            v-for="i in 5"
            :key="i"
            class="h-6 w-6 c-yellow-500"
            :class="{
              'i-carbon-star-filled': displayedScore >= i,
              'i-carbon-star': displayedScore < i,
            }"
            @mouseleave="isHoverActive = false"
            @click="onChangeRating()"
            @mouseover="hoverRating(i)"
          />
        </div>
      </div>
    </transition>
  </div>
</template>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
